import React, { Component } from 'react';
import Utils from './../../utils';
import PropTypes from 'prop-types';

/**
 * Motives swipe view HOC
 * @param {Component} SwipeViewComponent - swipe view
 * @returns {Component} - swipe view component with motives logic
 */
function swipeView(SwipeViewComponent) {

    return class extends Component {

        constructor(props) {
            super(props);

            this.slideRenderer = this.slideRenderer.bind(this);

            this.state = {
                id: Math.random().toString(36).substr(7)
            }
        }

        slideRenderer(params) {
            const { index } = params;
            const { slideCount, getSlideContent } = this.props;

            // return empty element as we cannot render a question < 0 index or out of bounds
            // this happens because rendering is called BEFORE index switching, meaning that when swiping from
            // second last to last slide, it will try to render the slide after that, before it actually switched
            if (index < 0 || index >= slideCount) {
                return (<div key={ `dummy-slide-${index}` } />);
            }

            // call to get the slide
            return getSlideContent(index);
        }

        componentDidUpdate(prevProps) {
            if (!Utils.compareData(prevProps.renderBindings, this.props.renderBindings)) {
                this.setState({
                    id: Math.random().toString(36).substr(7)
                });
            }
        }

        render() {
            const { activeIndex, slideCount } = this.props;

            // Notice that we pass through any additional props
            return (
                <SwipeViewComponent
                    id={ `swipeview-${this.state.id}` }
                    slideRenderer={ this.slideRenderer }
                    axis={ 'x' }
                    index={ activeIndex || 0 }
                    overscanSlideAfter={ activeIndex === (slideCount - 1) ? 0 : 1 }
                    overscanSlideBefore={ activeIndex === 0 ? 0 : 1 }
                    { ...Utils.excludeProps([
                        'slideCount',
                        'activeIndex',
                        'getSlideContent',
                        'slideRenderer',
                        'axis',
                        'index',
                        'overscanSlideAfter',
                        'overscanSlideBefore',
                        'renderBindings'
                    ], this.props) }
                />
            );
        }
    };
}

export { swipeView };

swipeView.PropTypes = {
    activeIndex: PropTypes.number,
    slideCount: PropTypes.number.isRequired,
    getSlideContent: PropTypes.func.isRequired,
    renderBindings: PropTypes.any
};

swipeView.defaultProps = {
    activeIndex: 0
};
